import { http } from '../../../../api/http';
import type { Turno } from '../types/turnos';

const ENDPOINT = '/planilla/turno';

export class TurnosService {
  static async getAll(): Promise<Turno[]> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  static async save(turno: Turno): Promise<Turno> {
    const response = await http.post(ENDPOINT, turno);
    return response.data;
  }

  static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }
}
